// Anatomia da página filha "Gerenciar conexões" (/allConnections) — mockup
// "Todas as Conexões": breadcrumb com selo SUPER, filtros, faixa de KPIs e
// tabela em CSS grid por conexão.
import { makeStyles, alpha } from "@material-ui/core/styles";
import { AEROS, stateText } from "../../styles/aerosTokens";

export const TABLE_GRID =
  "minmax(0,1.5fr) minmax(0,1.3fr) 150px 130px 165px 105px 120px";

const useAllConnectionsStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  const borderCard = isLight ? theme.palette.divider : "rgba(255,255,255,0.07)";

  return {
    breadcrumb: {
      display: "flex",
      alignItems: "center",
      gap: 6,
      fontSize: 12.5,
      color: theme.palette.text.secondary,
      "& .MuiSvgIcon-root": { fontSize: 16 },
    },
    backButton: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      fontSize: 12.5,
      fontWeight: 600,
      textTransform: "none",
      minWidth: 0,
      padding: "2px 4px",
      color: theme.palette.text.secondary,
      "&:hover": { color: AEROS.cyan, backgroundColor: "transparent" },
      "& .MuiSvgIcon-root": { fontSize: 16 },
    },
    currentCrumb: { color: theme.palette.text.primary, fontWeight: 600 },
    superBadge: {
      fontSize: 9.5,
      fontWeight: 800,
      letterSpacing: "0.08em",
      borderRadius: 5,
      padding: "1px 6px",
      marginLeft: 4,
      color: stateText(theme, "#C08BFF", "purple"),
      backgroundColor: alpha(theme.palette.primary.main, 0.18),
    },

    kpiGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(4,minmax(0,1fr))",
      gap: 12,
      marginBottom: 16,
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "repeat(2,minmax(0,1fr))",
      },
    },
    kpiCard: {
      backgroundColor: theme.palette.aeros.surface,
      border: `1px solid ${borderCard}`,
      borderRadius: 12,
      padding: "14px 16px",
    },
    kpiLabel: {
      fontSize: 11,
      fontWeight: 600,
      color: theme.palette.text.secondary,
      textTransform: "uppercase",
      letterSpacing: "0.06em",
    },
    kpiValue: {
      fontSize: 22,
      fontWeight: 700,
      letterSpacing: "-0.02em",
      marginTop: 4,
      fontVariantNumeric: "tabular-nums",
      color: theme.palette.text.primary,
    },

    companyCell: { display: "flex", alignItems: "center", gap: 10, minWidth: 0 },
    companyAvatar: {
      width: 30,
      height: 30,
      borderRadius: 9,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 11,
      fontWeight: 700,
      color: "#07080D",
      flex: "none",
    },
    companyName: {
      fontSize: 13,
      fontWeight: 600,
      color: theme.palette.text.primary,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    companyPlan: { fontSize: 11, color: theme.palette.text.secondary },
    connName: {
      fontSize: 13,
      fontWeight: 600,
      color: theme.palette.text.primary,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    mono: {
      fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
      fontSize: 12,
      color: theme.palette.text.secondary,
    },
    channelTag: {
      fontSize: 10.5,
      fontWeight: 600,
      borderRadius: 5,
      padding: "2px 8px",
      color: theme.palette.text.secondary,
      backgroundColor: isLight
        ? theme.palette.aeros.surface2
        : "rgba(255,255,255,0.06)",
      width: "fit-content",
    },
  };
});

export default useAllConnectionsStyles;
